import { render, staticRenderFns } from "./Pse.vue?vue&type=template&id=701a5b80&scoped=true"
import script from "./Pse.vue?vue&type=script&lang=js"
export * from "./Pse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a5b80",
  null
  
)

export default component.exports